import { useTheme } from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import { SaveDecisionForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import React from 'react';
import { useParams } from 'react-router-dom';



export type SaveDecisionModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SaveDecisionModalProps) => {
  const params = useParams();
  const theme = useTheme();
  return (
    <BasicFormModalLayout.FC
      title={`${props.id === '' ? 'Save' : 'Edit'} Finish`}
      subTitle='Enter Finish information below'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
      headerIcon={(
        <CustomIcon.large.FC
          icon='PLUS'
          stroke={theme.palette.primary.main}
        />
      )}
      id={props.id}
    >
      {/*  */}
      <SaveDecisionForm.FC
        id={props.id}
        installationId={params.installationId ?? ''}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );
};
